import { css } from '@emotion/react';
import { Container, styled } from '@mui/joy';
import { Outlet } from '@tanstack/react-router';
import { ReactNode } from 'react';

export const Root = styled(Container)(
  ({ theme }) => css`
    padding: ${theme.spacing(4)};
    flex: 1;
    display: flex;
    flex-direction: column;
  `,
);

type BackendContainerLayoutProps = {
  children?: ReactNode;
};

export function ContainerLayout({ children }: BackendContainerLayoutProps) {
  return <Root maxWidth="xl">{children || <Outlet />}</Root>;
}
